





import { Component, Vue } from "vue-property-decorator";

@Component
export default class FloatingLogo extends Vue {

  onBackClick(event: any) {
    if (event) {
      event.preventDefault()
    }
    this.$router.back();
  }
}
